import React from 'react';

const Tooltip = ({ description, children }) => {
  return (
    <div className="shahdana-tooltip">
      <span className="tooltiptext">{description}</span>
      {children}
    </div>
  );
};

export default Tooltip;
